import { useContext } from 'react'
import { clearAuthSession } from '@/root/shared-api/auth/authService'
import { AuthContextStateSetter } from '@/root/shared-providers/AuthContextProvider/AuthContext'

export const useSetAuthToken = () => {
  const setAuthState = useContext(AuthContextStateSetter)

  const saveToken = async (token: string | null, _rememberMe = false) => {
    if (!token) {
      setAuthState({ token: null, isAuth: false })
      await clearAuthSession()
      return
    }

    setAuthState({ token: null, isAuth: true })
  }

  const resetToken = async () => {
    setAuthState({ token: null, isAuth: false })

    try {
      await clearAuthSession()
    } catch {
      // Keep the UI logged out even if the session clear request fails.
    }
  }

  return { saveToken, resetToken }
}
